var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pad-child"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.getText("404")))]),_c('a',{staticClass:"dex-button box outline",attrs:{"href":"javascript:history.back()"}},[_c('i',{staticClass:"dexcon-chevron-left-thin"}),_c('span',[_vm._v(_vm._s(_vm.getText("back")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }